import PageComponent from '../PageComponent';
import Glide from '@glidejs/glide';

export default class Event extends PageComponent {
    init() {
        this.ready();
    }

    ready() {
        let slider = this.element.find('.gallery');
        new Glide(slider[0], {
            type: 'carousel',
            startAt: 0,
            perView: 1,
            autoplay:3600,
            gap: 0,
        }).mount();

        let offers = this.element.find('.tour-tab'),
            offerBodies = this.element.find('.tour-offer-body');

        offers.on('click', (e) => {
            offers.removeClass('active');
            offerBodies.removeClass('active');
            $(e.target).closest('.tour-tab').addClass('active');
            let offer = $(e.target).closest('.tour-tab').data('offer'),
                body = this.element.find('.tour-offer-body[data-offer="' + offer + '"]');
            body.addClass('active');
        });
    }
}
